import { render } from "./Сopyright.vue?vue&type=template&id=76b9bf66&scoped=true"
import script from "./Сopyright.vue?vue&type=script&lang=js"
export * from "./Сopyright.vue?vue&type=script&lang=js"

import "./Сopyright.vue?vue&type=style&index=0&id=76b9bf66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b9bf66"]])

export default __exports__